<!--
 * @Description: 确认支付页
 * @Date: 2020-12-11 14:59:17
-->
<template>
  <div class="detail" v-loading="loading">
    <!-- <el-button
      type="text"
      class="detail__top-btn"
      v-if="orderDetail.payStatus"
      @click="showDetail"
    >支付详情</el-button>-->
    <template v-if="currentData.pay1234 === 1">
      <div class="detail__content content fz14">
        <div class="content__box">
          <XrkSubtitle title="订单信息"></XrkSubtitle>
          <div class="content__item item">
            <div>
              <p>
                <span class="c666">订单编号：</span>
                <span class="c666">{{ orderBasic.orderNo }}</span>
              </p>
              <p></p>
              <p>
                <span class="c666">订单生成时间：</span>
                <span>{{ orderBasic.createDt }}</span>
              </p>
            </div>
          </div>
        </div>

        <div class="content__box">
          <XrkSubtitle title="收款方详情"></XrkSubtitle>
          <div
            class="content__item item"
            v-for="(item, index) in supplierAndThreePayPayItem"
            :key="index"
          >
            <div>
              <p>
                <span class="c666">收款方：</span>
                <span class="c333" v-if="item.csoOrderSupplierId">
                  {{ item.supplierName || '-' }}
                </span>
                <span class="c333" v-else>
                  共{{ item.userCountSet || 0 }}人
                </span>
              </p>
              <p>
                <span class="c666">支付状态：</span>
                <span class="c333">
                  {{ setItemPayStatus(item.payStatus, item.supplierId).text }}
                </span>
              </p>
              <p>
                <span class="c666">项目数：</span>
                <span class="c333">{{ item.projectCount || '-' }}个</span>
              </p>
              <p>
                <span class="c666">支付人数：</span>
                <span class="c333" v-if="item.csoOrderSupplierId">
                  {{ item.userCountSet || '-' }}人
                </span>
                <span class="c333" v-else>
                  {{ item.userCountSet - item.payFailedCount || 0 }}/{{
                    item.userCountSet
                  }}人
                </span>
              </p>
              <template v-if="showBankInfoItem(supplierAndThreePayPayItem[0])">
                <p>
                  <span class="c666">收款银行：</span>
                  <span class="c333">{{ item.bankName || '-' }}</span>
                </p>
                <p>
                  <span class="c666">收款方式：</span>
                  <span class="c333">{{ item.payType || '-' }}</span>
                </p>
                <p>
                  <span class="c666">收款账户：</span>
                  <span class="c333" v-if="item.csoOrderSupplierId">
                    {{ item.bankNo || '-' }}
                  </span>
                  <span class="c333" v-else>共{{ item.bankNo || 0 }}个</span>
                </p>
              </template>

              <!-- <p></p>
              <p>
                <span class="c666">到账时间：</span>
                <span class="c333">{{ item.finishPayDt || '-' }}</span>
              </p> -->
              <p>
                <span class="c666">项目结算金额：</span>
                <span class="c333 fz20">
                  {{ item.projectPrice | moneyFixed }}
                </span>
              </p>
            </div>
          </div>
        </div>
        <div class="content__box">
          <XrkSubtitle title="支付详情"></XrkSubtitle>

          <div class="content__item item">
            <div>
              <p>
                <span class="c666">订单状态：</span>
                <span class="fz24" :style="{ color: computePayStatus.color }">
                  {{ computePayStatus.text }}
                </span>
              </p>
              <p>
                <span class="c666">支付通道：</span>
                <span class="fz24">
                  {{ payBankFormatter(supplierAndThreePayPayItem[0]) }}
                </span>
              </p>
            </div>
            <div>
              <p>
                <span class="c666">服务商付款方式：</span>
                <span>
                  {{ supplierAndThreePayPayItem[0].csoPayType }}
                </span>
              </p>
            </div>
          </div>

          <!-- <table style="width:100%">
          <tbody>
            <tr>
              <td>
                <span class="c666"> 状态订单: </span>
                <span class="fz24" :style="{ color: computePayStatus.color }">
                  {{ computePayStatus.text }}
                </span>
              </td>
              <td>
                <span style="color: #e90b0b">
                  {{ computePayStatus.desc || '-' }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>-->

          <div class="content__item item">
            <div>
              <p>
                <span class="c666">项目数：</span>
                <span>{{ orderDetail.projectCount || '-' }}个</span>
              </p>
              <p>
                <span class="c666">支付人数：</span>
                <span>{{ orderDetail.userCountCount || '-' }}人</span>
              </p>
              <p>
                <span class="c666">项目结算金额：</span>
                <span>{{ orderDetail.initOrderPrice | moneyFixed }}</span>
              </p>
              <p>
                <template v-if="orderDetail.discountPrice">
                  <span class="c666">优惠金额：</span>
                  <span>{{ orderDetail.discountPrice | moneyFixed }}</span>
                </template>
              </p>
              <p>
                <span class="c666">订单支付金额：</span>
                <span>{{ orderDetail.orderPrice | moneyFixed }}</span>
              </p>
              <p>
                <span class="c666">项目参与人类型：</span>
                <span>
                  {{ orderDetail.userEnterpriseType | userEnterpriseTypeFil }}
                </span>
              </p>
              <p></p>
              <p>
                <span class="c666">本次支付金额：</span>
                <span style="font-size: 28px">
                  <span style="color: #409eff">
                    {{ thePayment | mFixed1 }}
                  </span>
                  &nbsp;&nbsp;元
                </span>
              </p>
            </div>
          </div>

          <!-- <table style="width: 100%" cellspacing="0" cellpadding="0">
          <tbody>
             <tr>
              <td>
                <span class="c666"> 状态订单: </span>
                <span class="fz24" :style="{ color: computePayStatus.color }">
                  {{ computePayStatus.text }}
                </span>
              </td>
              <td>
                <span style="color: #e90b0b">
                  {{ computePayStatus.desc || '-' }}
                </span>
              </td>
            </tr>
            <tr>
              <td>
                <span class="c666">项目数：</span>
                {{ orderDetail.projectCount || '-' }}
              </td>
              <td>
                <span class="c666">支付人数：</span>
                {{ orderDetail.userCountCount || '-' }}
              </td>
            </tr>
            <tr>
              <td>
                <span class="c666">项目结算金额：</span>
                {{ orderDetail.initOrderPrice | moneyFixed }}
              </td>
              <td>
                <span class="c666">优惠金额：</span>
                {{ orderDetail.discountPrice | moneyFixed }}
              </td>
            </tr>
            <tr>
              <td>
                <span class="c666">订单支付金额：</span>
                {{ orderDetail.orderPrice | moneyFixed }}
              </td>
              <td>
                <span class="c666">本次支付金额：</span>
                <span class="color-primary" style="font-size: 28px">
                  {{ orderDetail.sumCurrentPayAmount | mFixed1 }}
                </span>
                &nbsp;&nbsp; 元
              </td>
            </tr>
          </tbody>
        </table>-->
        </div>
      </div>
    </template>
    <template v-if="currentData.pay1234 === 2">
      <div class="detail__content content c333">
        <div class="content__box">
          <XrkSubtitle title="订单信息"></XrkSubtitle>
          <div class="content__item item ">
            <div>
              <p>
                <span class="c666">订单编号：</span>
                <span>{{ currentData.payOrderNo }}</span>
              </p>
              <p></p>
              <p>
                <span class="c666">订单生成时间：</span>
                <span>{{ currentData.createDt }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="content__box">
          <XrkSubtitle title="收款方详情"></XrkSubtitle>
          <div class="content__item item">
            <div>
              <p>
                <span class="c666">收款方：</span>
                <span>{{ currentData.platformName }}</span>
              </p>
              <p></p>
              <p>
                <span class="c666">支付状态：</span>
                <span>
                  {{
                    setItemPayStatus(
                      currentData.payStatus,
                      currentData.supplierId
                    ).text
                  }}
                </span>
              </p>
              <p>
                <span class="c666">收款银行：</span>
                <span>{{ currentData.platformBankName }}</span>
              </p>
              <p>
                <span class="c666">收款方式：</span>
                <span>{{ currentData.platformPayType }}</span>
              </p>
              <p>
                <span class="c666">收款账号：</span>
                <span>{{ currentData.platformBankNo }}</span>
              </p>
              <!-- <p></p>
              <p>
                <span class="c666">到账时间：</span>
                <span>{{ currentData.finishPayDt || '-' }}</span>
              </p> -->
              <p>
                <span class="c666">结算金额：</span>
                <span>{{ currentData.platformServices | moneyFixed }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="content__box">
          <XrkSubtitle title="支付详情"></XrkSubtitle>
          <div class="content__item item">
            <div>
              <p>
                <span class="c666">订单状态：</span>
                <span
                  class="fz24"
                  :style="{
                    color: setItemPayStatus(
                      currentData.payStatus,
                      currentData.supplierId
                    ).color
                  }"
                >
                  {{
                    setItemPayStatus(
                      currentData.payStatus,
                      currentData.supplierId
                    ).text
                  }}
                </span>
              </p>
              <p>
                <span class="c666">支付通道：</span>
                <span class="fz24">
                  {{ payBankFormatter(currentData) }}
                </span>
              </p>
              <p>
                <span class="c666">服务商付款方式：</span>
                <span>
                  {{ currentData.csoPayType }}
                </span>
              </p>
            </div>
          </div>
          <div class="content__item item">
            <div>
              <p>
                <span class="c666">费用类型：</span>
                <span>{{ currentData.platformPayDes }}</span>
              </p>
              <p>
                <span class="c666">项目参与人类型：</span>
                <span>
                  {{ orderDetail.userEnterpriseType | userEnterpriseTypeFil }}
                </span>
              </p>
              <p>
                <span class="c666">结算金额：</span>
                <span>{{ currentData.platformServices | moneyFixed }}</span>
              </p>
              <p v-if="currentData.discountPrice">
                <template>
                  <span class="c666">优惠金额：</span>
                  <span>{{ currentData.discountPrice | moneyFixed }}</span>
                </template>
              </p>
              <p>
                <span class="c666">本次支付金额：</span>
                <span style="font-size: 28px">
                  <span style="color: #409eff">
                    {{ currentData.platformServices | mFixed1 }}
                  </span>
                  &nbsp;&nbsp; 元
                </span>
              </p>
              <p>
                <span class="c666">订单支付金额：</span>
                <span>{{ currentData.platformServices | moneyFixed }}</span>
              </p>
              <!-- <p>
              <span class="c666">本次支付金额：</span>
              <span>{{currentData.platformServices | moneyFixed}}</span>
            </p> -->
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="currentData.pay1234 === 3">
      <div v-if="currentData.payStatus == 1" class="imgBox">
        <img src="@/assets/3.png" />
        <div class="imgLabel">支付中</div>
        <div class="imgDes">
          系统正在对订单进行支付，请耐心等待，终端到账时间为T+1天
        </div>
      </div>
      <div v-else-if="currentData.payStatus == 3" class="imgBox">
        <img src="@/assets/2.png" />
        <div class="imgLabel">支付失败</div>
        <div class="imgDes">本次支付失败，请重新提交支付</div>
      </div>
      <div v-else-if="currentData.payStatus == 2" class="imgBox">
        <img src="@/assets/1.png" />
        <div class="imgLabel">支付成功</div>
      </div>
      <div class="flexBox">
        <div class="leftBox">
          <b>订单编号：</b>
          {{ currentData.payOrderNo }}
        </div>
      </div>
      <div class="flexBox">
        <div>
          <b>企业名称：</b>
          {{ currentData.supplierName }}
        </div>
      </div>
      <div class="flexBox borderBtm">
        <div class="leftBox">
          <b>任务月度：</b>
          {{ currentData.orderMonth }}
        </div>
      </div>
      <div class="flexBox borderBtm" style="padding-top:20px;">
        <div class="leftBox">
          <b style="color:#bfbfbf;">综合服务费：</b>
          {{ currentData.orderPrice | money }}
        </div>
        <!-- <div>
          到账时间：
          <b>{{ currentData.receiveDt | transAllTime }}</b>
        </div> -->
      </div>
      <div style="text-align:right;margin-bottom:50px;">
        本次支付金额：
        <b style="color:#1989FA;font-size:30px;">
          {{ currentData.orderPrice | money }}
        </b>
        <i style="font-size:20px;font-style:normal">元</i>
      </div>
    </template>
    <template v-if="currentData.pay1234 === 4">
      <div v-if="currentData.payStatus == 1" class="imgBox">
        <img src="@/assets/3.png" />
        <div class="imgLabel">支付中</div>
        <div class="imgDes">
          系统正在对订单进行支付，请耐心等待，终端到账时间为T+1天
        </div>
      </div>
      <div v-else-if="currentData.payStatus == 3" class="imgBox">
        <img src="@/assets/2.png" />
        <div class="imgLabel">支付失败</div>
        <div class="imgDes">本次支付失败，请重新提交支付</div>
      </div>
      <div v-else-if="currentData.payStatus == 2" class="imgBox">
        <img src="@/assets/1.png" />
        <div class="imgLabel">支付成功</div>
      </div>
      <div class="flexBox">
        <div class="leftBox">
          <b>订单编号：</b>
          {{ currentData.orderNo }}
        </div>
      </div>
      <div class="flexBox">
        <div>
          <b>企业名称：</b>
          {{ currentData.enterpriseName }}
        </div>
      </div>
      <div class="flexBox borderBtm">
        <div class="leftBox">
          <b>任务月度：</b>
          {{ currentData.ChargeDt }}
        </div>
      </div>
      <div class="flexBox borderBtm" style="padding-top:20px;">
        <div class="leftBox">
          <b style="color:#bfbfbf;">杂费：</b>
          {{ currentData.orderPrice | money }}
        </div>
        <!-- <div v-if="currentData.finishPayDt">
          到账时间：
          <b>{{ transDt(currentData.finishPayDt) }}</b>
        </div> -->
      </div>
      <div style="text-align:right;margin-bottom:50px;">
        本次支付金额：
        <b style="color:#1989FA;font-size:30px;">
          {{ currentData.orderPrice | money }}
        </b>
        <i style="font-size:20px;font-style:normal">元</i>
      </div>
    </template>
    <p style="margin-bottom:30px">
      <span style="color: #e90b0b">
        {{ computePayStatus.desc }}
      </span>
    </p>
    <el-pagination
      style="text-align: center"
      v-if="datas.length > 1"
      :current-page.sync="currentPage"
      :page-size="1"
      layout="total, prev, pager, next"
      :total="datas.length"
    ></el-pagination>
    <div class="xrk-dialog__btns">
      <el-button @click="cancel">返回</el-button>
      <el-button type="primary" @click="confirm" v-if="showPayButton">
        支付
      </el-button>
    </div>
  </div>
</template>

<script>
import dateFormat from '@/tools/dateFormat';
import { userEnterpriseTypeMapping } from '@/page/settlementCenter/common/mapping.js';

import { csoCustomerOrder } from '@/api/ajax';
import XrkSubtitle from '@/components/XrkSubtitle';
import { PAY_BANK_TYPE_KEY } from '@/common/constants/bank';
import { payBankFormatter, payTypeFormatter } from '@/common/fields/bank';

// import {moneyFixed} from '@/tools/money'
// 三级支付状态
const payStatusMap = {
  0: {
    text: '待支付',
    color: '#F3630A',
    desc: '请您确认信息无误后进行订单支付。',
    status: 0
  },
  1: {
    text: '支付中',
    color: '#332CF9',
    desc: '系统正在对订单进行支付，请耐心等待。',
    status: 1
  },
  2: {
    text: '部分支付成功',
    color: '#19E0D9',
    desc: '请您对支付失败订单继续发起支付。',
    status: 2
  },
  3: {
    text: '支付成功',
    color: '#19E0D9',
    desc: '您当前订单已支付成功。感谢您的使用！',
    status: 3
  },
  4: {
    text: '支付失败 ',
    color: '#F51258',
    desc: '本次支付失败，请您重新提交支付。',
    status: 4
  }
};
// 四级支付状态
const fourPayStatusMap = {
  0: {
    text: '待支付',
    color: '#F3630A',
    desc: '请您确认信息无误后进行订单支付。',
    status: 0
  },
  1: {
    text: '支付中',
    color: '#332CF9',
    desc: '系统正在对订单进行支付，请耐心等待。',
    status: 1
  },
  2: {
    text: '支付成功',
    color: '#19E0D9',
    desc: '您当前订单已支付成功。感谢您的使用！',
    status: 2
  },
  3: {
    text: '支付失败',
    color: '#F51258',
    desc: '本次支付失败，请您重新提交支付。',
    status: 3
  }
};

export default {
  name: 'OrderPayDetail',
  props: {
    csoCustomOrderIds: {
      type: String,
      default: '',
      required: false
    },
    csoOrderServicesIds: {
      type: [String, Number],
      required: false,
      default: ''
    },
    comprehensiveOrderIds: {
      type: String,
      required: false,
      default: ''
    },
    csoBusServicesIds: {
      type: String,
      required: false,
      default: ''
    },
    authOrderIds: {
      type: String,
      required: false,
      default: ''
    },
    orderNo: {
      type: String,
      default: ''
    }
  },
  filters: {
    userEnterpriseTypeFil(v) {
      return (userEnterpriseTypeMapping[v] || { label: '-' }).label;
    },
    moneyFixed: num => {
      if (!isNaN(num)) {
        let n = (Number(num) / 100).toFixed(2);
        return `${n} 元`;
      } else {
        return '-';
      }
    },
    mFixed1: num => {
      if (!isNaN(num)) {
        let n = (Number(num) / 100).toFixed(2);
        return `${n}`;
      } else {
        return '-';
      }
    }
  },
  data() {
    return {
      payBankFormatter,
      payTypeFormatter,
      PAY_BANK_TYPE_KEY,
      currentPage: 1, // 当前页码，需要-1后与currentIndex对应
      currentIndex: -1, // 当前显示数据下标：⬇
      datas: [], // 多组数据，期内结构：⬇
      supplierAndThreePayPayItem: [], // 混合了 四级和其他
      // supplierPayItem: [], //订单中的四级结构（供应商）信息
      // threePayItem: [], //订单中的三级结构信息  TODO: 这个需要区分
      orderBasic: {}, //订单基础信息
      orderDetail: {}, //订单右下角几个关键数据统计
      loading: true
    };
  },
  components: {
    XrkSubtitle
  },
  watch: {
    currentIndex(v) {
      // 设置当前数据。通过接口key设值对应key； orderBasic orderDetail
      Object.assign(this.$data, this.datas[v]);
    },
    currentPage(v) {
      this.currentIndex = v - 1;
    }
  },
  computed: {
    currentData() {
      return this.datas[this.currentIndex] || {};
    },
    thePayment() {
      let { payStatus, orderPrice, sumCurrentPayAmount } = this.orderDetail;
      // 已支付则使用orderPrice
      return payStatus === 3 ? orderPrice : sumCurrentPayAmount;
    },
    computePayStatus() {
      if (~this.currentIndex) {
        return payStatusMap[this.orderDetail.payStatus];
      }
      return {};
    },
    // 综合服务费，平台服务费，杂费使用四级状态
    showPayButton() {
      let canArr = this.currentData.pay1234 !== 1 ? [0, 3] : [0, 2, 4];
      return canArr.includes(this.orderDetail.payStatus);
    }
  },
  methods: {
    showBankInfoItem(v) {
      //众邦和富友展示银行相关字段 网银支付不展示
      return ['zbBank', 'fyBank'].includes(v[PAY_BANK_TYPE_KEY]);
    },

    transDt(v) {
      if (v) {
        return dateFormat(v);
      } else {
        return '';
      }
    },
    /**
     * @description: 根据当前数据是否有供应商设置对应支付状态
     * @param {number} stauts 当前支付状态
     * @param {number} hasSupplier 供应商ID
     * @return {object}
     */
    setItemPayStatus(stauts, hasSupplier) {
      let map = hasSupplier ? fourPayStatusMap : payStatusMap;
      return map[stauts] || { text: '-' };
    },
    showDetail() {
      this.$xrkDialog({
        title: '支付记录',
        showConfirm: false,
        showCancel: false,
        $slots: {
          default: this.$createElement(require('./orderPayDetail').default, {
            props: {
              csoOrderIds: this.csoCustomOrderIds
            }
          })
        }
      });
    },
    cancel() {
      this.$xrkDialog.remove();
    },
    confirm() {
      const payPassagewayCode =
        this.currentData.payPassagewayCode ||
        this.supplierAndThreePayPayItem[0].payPassagewayCode;

      this.$xrkDialog({
        title: '确认支付',
        showConfirm: false,
        showCancel: false,
        $slots: {
          default: this.$createElement(require('./orderConfirmSms').default, {
            props: {
              csoCustomOrderIds: this.csoCustomOrderIds,
              csoOrderServicesIds: this.csoOrderServicesIds,
              comprehensiveOrderIds: this.comprehensiveOrderIds,
              authOrderIds: this.authOrderIds,
              csoBusServicesIds: this.csoBusServicesIds,
              payPassagewayCode
            }
          })
        }
      });
    }
  },
  async created() {
    let params = {};
    for (let propsKey in this.$props) {
      if (
        Object.prototype.toString
          .call(this.$props[propsKey])
          .toLowerCase()
          .includes('array')
      ) {
        params[propsKey] = this.$props[propsKey].join(',');
      } else {
        params[propsKey] = this.$props[propsKey];
      }
    }
    let { pdata } = await csoCustomerOrder.queryPayOrderDetailAll(params);
    pdata.customerOrderList.forEach(item => {
      item.pay1234 = 1;
      item.supplierAndThreePayPayItem = [
        ...item.supplierPayItem,
        ...item.threePayItem
      ];
    });
    pdata.csoOrderServicesList.forEach(item => {
      item.pay1234 = 2;
      item.supplierId = 1;
      item.orderBasic = item.orderDetail = item;
    });
    //商务服务费和平台服务费一样服务类型为商务服务费
    pdata.busCsoOrderServicesList.forEach(item => {
      item.pay1234 = 2;
      item.supplierId = 1;
      item.orderBasic = item.orderDetail = item;
    });
    this.datas = [
      ...pdata.customerOrderList,
      ...pdata.csoOrderServicesList,
      ...pdata.busCsoOrderServicesList
    ];
    this.currentIndex = 0;
    this.loading = false;
  }
};
</script>

<style scoped lang="scss">
.imgBox {
  text-align: center;
  img {
    width: 112px;
    height: 112px;
    margin-bottom: 20px;
  }
  .imgLabel {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .imgDes {
    color: #b4cfff;
    margin-bottom: 50px;
    font-size: 14px;
  }
}
.app-info {
  padding: 8px;
}
.c666 {
  min-width: 110px;
  display: inline-block;
}
.fw500 {
  font-weight: 500;
}
.fz24 {
  font-size: 24px;
  line-height: 24px;
  font-weight: 500;
}
.daizhifu {
  color: #f3630a;
}
.detail {
  width: 880px;
}
.content {
  width: 880px;
  &__box {
    margin-bottom: 50px;
    &:last-child {
      margin-bottom: 10px;
    }
    & > table {
      margin-top: 24px;
      border-collapse: 0;
      border: 8px solid #f0f2f5;
      // background: #f0f2f5;
      padding: 8px;
      tbody {
        // background: #fff;
        td {
          padding: 8px;
        }
      }
    }
  }

  &__item {
    background: #f0f2f5;
    padding: 8px;
    border-radius: 4px;
    margin-top: 24px;
    div {
      background: #fff;
      display: flex;
      flex-wrap: wrap;
      padding: 16px;
    }
    p {
      width: 50%;
      margin: 4px 0;
      display: inline-flex;
      align-items: baseline;
    }
  }
}
</style>
